import api from '../config/api';
import { useMutation, useQuery, useQueryClient } from 'react-query';

export const profileLikesKeys = {
  count: (profileId) => ['profileLikes', 'count', String(profileId || '')],
  status: (profileId) => ['profileLikes', 'status', String(profileId || '')]
};

export function useProfileLikeCount(profileId) {
  return useQuery(
    profileLikesKeys.count(profileId),
    async () => {
      const res = await api.get(`/api/profile-likes/${encodeURIComponent(profileId)}/count`);
      return res.data;
    },
    { enabled: !!profileId }
  );
}

export function useProfileLikeStatus(profileId, { enabled = true } = {}) {
  return useQuery(
    profileLikesKeys.status(profileId),
    async () => {
      const res = await api.get(`/api/profile-likes/${encodeURIComponent(profileId)}/status`);
      return res.data;
    },
    { enabled: !!profileId && enabled }
  );
}

export function useToggleProfileLike(profileId) {
  const qc = useQueryClient();
  return useMutation(
    async () => {
      const res = await api.post(`/api/profile-likes/${encodeURIComponent(profileId)}/toggle`, {});
      return res.data;
    },
    {
      onSuccess: () => {
        qc.invalidateQueries(profileLikesKeys.count(profileId));
        qc.invalidateQueries(profileLikesKeys.status(profileId));
      }
    }
  );
}

